module.exports = __webpack_public_path__ + "static/FutureOfTransport_p7.698073fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FutureOfTransport/FutureOfTransport_p7.png
// module id = 524
// module chunks = 202548274545758